import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        formRowRoot: {
            backgroundColor: '#fff',
            border: '1px solid #dadce0',
            borderRadius: 0,
            padding: 24,
            position: 'relative',
            borderTop: 'none',
            borderBottom: 'none',
        },
        error: {
            border: '1px solid #d93025',
        },
        rowLabel: {
            fontFamily: 'Roboto',
            fontSize: '17px',
            lineHeight: '20px',
            color: '#000000',
            fontWeight: 500,
            width: '100%',
            wordBreak: 'break-word',
            marginBottom: theme.spacing(2),
        },
        rowInputRoot: {
            width: '65%',
        },
        required: {
            fontSize: '14px',
            fontWeight: 400,
            letterSpacing: '.2px',
            color: '#d93025',
            lineHeight: '20px',
            whiteSpace: 'pre-wrap',
            marginTop: theme.spacing(2),
        },
        placeholderDiv: {
            height: 19,
        },
        selectAdornment: {
            marginRight: theme.spacing(3),
        },
        savingContainer: {
            marginLeft: theme.spacing(1),
        },
        calendarAdornment: {
            height: 20,
        },
        linkButton: {
            background: 'none!important',
            border: 'none',
            padding: '0!important',
            /*input has OS specific font-family*/
            fontFamily: 'arial, sans-serif',
            color: '#069',
            textDecoration: 'underline',
            cursor: 'pointer',
        },
    }),
);
